import { CommonUtility } from '../common';

export function normalizeCode(codeStr: unknown): unknown {
  if (!codeStr || typeof codeStr !== 'string') return codeStr;
  // Remove leading zeros but keep at least one digit
  return codeStr.replace(/^0+(?=\d)/, '') || codeStr;
}

export interface IPackingLineItemForCodeMatch {
  status?: string;
  productId?: {
    upc?: string;
    p_sku?: string;
    barcode_identifiers?: string[];
  };
}

/** Whether a line item matches a scanned code (UPC, SKU, or barcode_identifiers), ignoring leading zeros. */
export function itemMatchesCode(
  item: IPackingLineItemForCodeMatch,
  code: string,
  excludeStatus: string,
): boolean {
  if (item.status === excludeStatus) return false;

  const upc = item?.productId?.upc;
  const sku = item?.productId?.p_sku;
  let codes: unknown[] = [upc, sku];
  if (CommonUtility.isValidArray(item.productId?.barcode_identifiers)) {
    codes = [...codes, ...item.productId.barcode_identifiers];
  }

  if (codes.includes(code)) return true;

  codes = codes.map(x => normalizeCode(x));
  const normalizedCode = normalizeCode(code);

  return codes.includes(normalizedCode);
}

export function formatPackingItemLabelFileName(
  orderDisplayId: string | undefined | null,
  oneBasedIndex: number,
): string {
  return `${orderDisplayId} - ${oneBasedIndex}`;
}

export function formatTotePackageLabelFileName(
  orderDisplayId: string | undefined | null,
  toteNumber: string | undefined | null,
  packageOneBasedIndex: number,
): string {
  return `${orderDisplayId} - ${toteNumber} - Package ${packageOneBasedIndex}`;
}
